<template>
  <validation-observer v-slot="{ handleSubmit }">
    <div class="row">
      <div class="col-md-12 text-bold bold mb-3">
        <i class="fas fa-user-check color-orange" />
        Entregada al CSEE
      </div>
      <div class="col-md-3">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-date-picker
            v-model="model.deliveryDate"
            class-container="w-100"
            custom-error-msg="Favor seleccione la fecha de entrega."
            :error="errors[0]"
            label="Fecha:"
            :max-date="new Date()"
            :min-date="beforeBankRequestDate"
            placeholder="DD/MM/YYYY"
          />
        </validation-provider>
      </div>
      <div class="col-md-4">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-drop-down
            v-model="deliveryTypeSelected"
            :clearable="false"
            custom-error-msg="Favor seleccione CSEE."
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="CSEE"
            :options="deliveryTypes"
            placeholder="Seleccione"
          />
        </validation-provider>
      </div>
      <div class="col-md">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-input
            v-model="model.name"
            custom-error-msg="Favor indique el nombre de la persona que recibe."
            :error="errors[0]"
            label="Nombre de la persona que recibe:"
          />
        </validation-provider>
      </div>

      <div class="col-md-12 text-right mt-3 pt-1">
        <action-button
          i="fas fa-times-circle"
          text="Cancelar"
          variant="outline-danger mr-3"
          @click="$emit('on-cancel')"
        />
        <action-button
          i="fas fa-save"
          text="Guardar"
          variant="success"
          @click="handleSubmit(submit)"
        />
      </div>
    </div>
  </validation-observer>
</template>

<script>
import CustomDatePicker from 'custom-date-picker';
import CustomInput from 'CustomInput';
import alertMixin from '@/mixins/alert.mixin';
import { putCseeDelivery as _putCseeDelivery } from '@/modules/shared/cardHandling.api';
import CustomDropDown from 'custom-drop-down';
import { getCardDeliveryTypes as _getCardDeliveryTypes } from '@/modules/shared/code.api.js';
import moment from 'moment';
export default {
  name: 'DeliveredCsee',
  components: {
    CustomDatePicker,
    CustomDropDown,
    CustomInput,
  },
  mixins: [alertMixin],
  props: {
    id: {
      type: Number,
      default: 0,
    },
    bankRequestDate: {
      type: Date,
      default: null,
    },
  },
  data: () => ({
    model: {
      deliveryTypeId: null,
      name: null,
      deliveryDate: null,
      becaCardId: null,
    },
    deliveryTypeSelected: null,
    deliveryTypes: [],
  }),
  computed: {
    beforeBankRequestDate() {
      return moment(this.bankRequestDate)
        .subtract(1, 'days')
        .toDate();
    },
  },
  async mounted() {
    const { data } = await _getCardDeliveryTypes();
    this.deliveryTypes = data;
  },
  methods: {
    async submit() {
      this.model.becaCardId = this.id;
      this.model.deliveryTypeId = this.deliveryTypeSelected.id;
      await _putCseeDelivery(this.model)
        .then(() => {
          this.ShowToast(
            'Confirmación',
            'La entrega ha sido realizada exitosamente.',
            'success'
          );
          this.$emit('on-saved');
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
  },
};
</script>
<style scoped lang="scss"></style>
